// "Posted within" presets, in hours. Fixed choices instead of a 0-30 day slider: boards are
// swept every hour to every 3 hours, so hour-level windows are real, and one click beats dragging.
//
// No 3h preset: on a sweep that runs up to every 3 hours a 3h window is thin for most of each
// cycle, so offering it sold a filter that mostly returned nothing. 14d was dropped as well -
// between 7d and 30d it made no decision anyone was actually making.
export const POSTED_WITHIN_PRESETS = [
  { hours: 6, label: "6h" },
  { hours: 12, label: "12h" },
  { hours: 24, label: "24h" },
  { hours: 72, label: "3d" },
  { hours: 168, label: "7d" },
  { hours: 720, label: "30d" },
];

// What the dates actually mean. Shown under the presets. The window compares the job board's
// own posting date (Greenhouse on first_published, so an edited posting is not a new one); boards
// that give no date at all are timed from when the job first appeared to us. The old wording said
// the opposite of what the query did (decision 2026-09-13: the board's posted date).
export const POSTED_WITHIN_DISCLOSURE =
  "Dates are the job board's posting date. Boards that give none (JazzHR, Breezy, Jobvite, Workday) are timed from when we first saw the job.";

const MAX_WINDOW_HOURS = 24 * 365;

// The smallest offered window that still covers `hours`, or the widest when none does. Rounding
// up rather than to the nearest preset means a snapped filter never hides a job the user's saved
// window included, and it needs no tie-break.
const coveringPreset = (hours) =>
  (POSTED_WITHIN_PRESETS.find((p) => p.hours >= hours) ?? POSTED_WITHIN_PRESETS[POSTED_WITHIN_PRESETS.length - 1]).hours;

const isWindow = (hours) => Number.isFinite(hours) && hours > 0 && hours < MAX_WINDOW_HOURS;

// The active window in hours, snapped to a preset we still offer. Two kinds of stored filter need
// snapping: profiles saved before this existed hold an absolute cutoff, and profiles saved while
// 3h/14d were on offer hold a window with no chip. Snapping both here keeps the chip, the label
// and the query in agreement - applyCards sends this value, not the raw stored one.
export const postedWithinHours = (filters) => {
  if (isWindow(filters?.postedWithinHours)) return coveringPreset(filters.postedWithinHours);
  if (!filters?.postedAfterTimestamp) return null;
  const hours = (Date.now() - Number(filters.postedAfterTimestamp)) / 3_600_000;
  return isWindow(hours) ? coveringPreset(hours) : null;
};

export const postedWithinLabel = (hours) =>
  POSTED_WITHIN_PRESETS.find((p) => p.hours === hours)?.label ?? null;
